import Actions from ".";
import { get, post, put, deleteCall } from "../../../utils/api";
import { API_ERROR_MESSAGE, DEFAULT_RECORD_LIMIT } from "../../../constants";

const getCategories =
  (categoryID = "") =>
  async (dispatch) => {
    dispatch(
      Actions.updateProperties({
        loadingCategories: true,
        successCategories: false,
      })
    );
    try {
      const data = await get(`categories?parentId=${categoryID}`);
      if (data.statusCode === 200) {
        dispatch(
          Actions.updateProperties({
            loadingCategories: false,
            error: "",
            successCategories: true,
            [categoryID ? "subCategories" : "categories"]: data.response,
            parentSubCategoryID: categoryID ? data.response[0].id : 0,
          })
        );
        if (!categoryID) {
          const [category] = data.response;
          dispatch(getCategories(category.id));
          dispatch(Actions.updateProperty("parentCategoryID", category.id));
        }
      } else {
        dispatch(
          Actions.updateProperties({
            loadingCategories: false,
            error:
              data.statusCode === 404 ? "" : data.message || API_ERROR_MESSAGE,
            [categoryID ? "subCategories" : "categories"]: [],
            parentSubCategoryID: 0,
          })
        );
      }
      if (categoryID && (data.statusCode === 200 || data.statusCode === 404)) {
        //         const [category] = data.response
        // console.log("22222222222222222222",categoryID)

        dispatch(getProducts(categoryID));
      }
    } catch (e) {
      dispatch(
        Actions.updateProperties({
          loadingCategories: false,
          error: e.message || API_ERROR_MESSAGE,
          [categoryID ? "subCategories" : "categories"]: [],
        })
      );
    }
  };

const getProducts = () => async (dispatch, getState) => {
  const {
    products: { parentCategoryID, parentSubCategoryID },
  } = getState();
  dispatch(Actions.updateProperty("loading", true));
  try {
    let url = `products?limit=${DEFAULT_RECORD_LIMIT}&parentCategoryId=${parentCategoryID}`;
    if (parentSubCategoryID) {
      url = url + `&parentSubCategoryId=${parentSubCategoryID}`;
    }
    const data = await get(url);
    if (data.statusCode === 200) {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: "",
          success: true,
          list: data.response.products || [],
          nextPageToken: (data.response || {}).nextPageToken,
          totalCount: data.response.totalCount,
        })
      );
    } else {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error:
            data.statusCode === 404 ? "" : data.message || API_ERROR_MESSAGE,
          list: [],
          nextPageToken: null,
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loading: false,
        error: e.message || API_ERROR_MESSAGE,
        list: [],
        nextPageToken: null,
      })
    );
  }
};

const searchProducts = () => async (dispatch, getState) => {
  const {
    products: { searchText },
  } = getState();
  dispatch(Actions.updateProperty("loading", true));
  try {
    const data = await get(`products/search/title?searchText=${searchText}`);
    if (data.statusCode === 200 && data.response) {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: "",
          success: true,
          list: data.response.products || [],
          nextPageToken: null,
        })
      );
    } else {
      dispatch(
        Actions.updateProperties({
          loading: false,
          list: [],
          nextPageToken: null,
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loading: false,
        error: e.message || API_ERROR_MESSAGE,
        nextPageToken: null,
        list: [],
      })
    );
  }
};

const addProducts = (body) => async (dispatch) => {
  console.log(body);
  dispatch(Actions.updateProperty("loading", true));
  try {
    const data = await post(`products/add-product`, body, {
      contentType: "multipart/form-data",
    });
    if (data.statusCode === 200) {
      dispatch(
        Actions.updateProperties({
          loading: false,
          message: data.message || "Discount added successfully",
        })
      );
      dispatch(getProducts());
    } else {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: API_ERROR_MESSAGE,
          list: [],
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loading: false,
        error: e.message || API_ERROR_MESSAGE,
      })
    );
  }
};

const loadMoreProducts = () => async (dispatch, getState) => {
  const {
    products: { nextPageToken, list },
  } = getState();
  dispatch(Actions.updateProperty("loading", true));
  try {
    const data = await get(`products?nextPageToken=${nextPageToken}`);
    if (data.statusCode === 200 && data.response) {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: "",
          success: true,
          list: [...list, ...data.response.products],
          nextPageToken: (data.response || {}).nextPageToken,
        })
      );
    } else {
      dispatch(
        Actions.updateProperties({
          loading: false,
          nextPageToken: null,
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loading: false,
        error: e.message || API_ERROR_MESSAGE,
        nextPageToken: null,
      })
    );
  }
};

const getProductDetails = (productID) => async (dispatch, getState) => {
  dispatch(Actions.updateProperty("loading", true));
  try {
    const data = await get(`products/${productID}`);
    if (data.statusCode === 200) {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: "",
          success: true,
          data: data.response || {},
        })
      );
    } else {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error:
            data.statusCode === 404 ? "" : data.message || API_ERROR_MESSAGE,
          data: {},
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loading: false,
        error: e.message || API_ERROR_MESSAGE,
        data: {},
      })
    );
  }
};

const clearProductDetails = (productID) => async (dispatch, getState) => {
  dispatch(
    Actions.updateProperties({
      data: {},
    })
  );
};

const uploadCategoryImage = (request) => async (dispatch) => {
  dispatch(Actions.updateProperty("loadingCategories", true));
  try {
    const { id, file, parentID } = request;
    const body = new FormData();
    body.append("file", file);
    const data = await post(`categories/upload/${id}`, body, {
      contentType: "multipart/form-data",
    });
    if (data.statusCode === 200) {
      dispatch(Actions.updateProperty("loadingCategories", false));
      dispatch(getCategories(parentID));
    } else {
      dispatch(
        Actions.updateProperties({
          loadingCategories: false,
          error: data.message || API_ERROR_MESSAGE,
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loadingCategories: false,
        error: e.message || API_ERROR_MESSAGE,
      })
    );
  }
};

const deleteCategory = (request) => async (dispatch) => {
  dispatch(Actions.updateProperty("loadingCategories", true));
  try {
    const { id } = request;
    const data = await deleteCall(`categories/${id}`);
    if (data.statusCode === 200) {
      dispatch(Actions.updateProperty("loadingCategories", false));
      dispatch(getCategories());
    } else {
      dispatch(
        Actions.updateProperties({
          loadingCategories: false,
          error: data.message || API_ERROR_MESSAGE,
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loadingCategories: false,
        error: e.message || API_ERROR_MESSAGE,
      })
    );
  }
};

const deleteProduct = (id) => async (dispatch) => {
  dispatch(Actions.updateProperty("loadingCategories", true));
  try {
    const data = await deleteCall(`products/${id}`);
    if (data.statusCode === 200) {
      dispatch(Actions.updateProperty("loadingCategories", false));
      dispatch(getCategories());
    } else {
      dispatch(
        Actions.updateProperties({
          loadingCategories: false,
          error: data.message || API_ERROR_MESSAGE,
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loadingCategories: false,
        error: e.message || API_ERROR_MESSAGE,
      })
    );
  }
};

const uploadProductImages = (id, files) => async (dispatch) => {
  dispatch(Actions.updateProperty("loading", true));
  try {
    const data = await post(
      `products/upload-product-images?productId=${id}`,
      files,
      { contentType: "multipart/form-data" }
    );
    if (data.statusCode === 200) {
      dispatch(Actions.updateProperty("loading", false));
    } else {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: data.message || API_ERROR_MESSAGE,
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loading: false,
        error: e.message || API_ERROR_MESSAGE,
      })
    );
  }
};

const deleteProductImages = (id, imageArray) => async (dispatch) => {
  dispatch(Actions.updateProperty("loading", true));
  try {
    let body = {
      productId: id.toString(),
      productImages: imageArray,
    };
    const data = await deleteCall("products/product-images", body);
    if (data.statusCode === 200) {
      dispatch(Actions.updateProperty("loading", false));
    } else {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: data.message || API_ERROR_MESSAGE,
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loading: false,
        error: e.message || API_ERROR_MESSAGE,
      })
    );
  }
};

const saveCategory = (body) => async (dispatch) => {
  dispatch(Actions.updateProperty("loading", true));
  dispatch(Actions.updateProperty("success", false));
  try {
    const data = await post(`categories/add`, body, {
      contentType: "multipart/form-data",
    });
    if (data.statusCode === 200) {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: data.message,
          success: true,
        })
      );
      dispatch(getCategories());
    } else {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: data.message || API_ERROR_MESSAGE,
          success: true,
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loading: false,
        error: e.message || API_ERROR_MESSAGE,
      })
    );
  }
};

const saveProductDetails = (id, body) => async (dispatch) => {
  dispatch(Actions.updateProperty("loading", true));
  dispatch(Actions.updateProperty("success", false));
  try {
    const data = await put(`products/${id}`, body);
    if (data.statusCode === 200) {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: data.message,
          success: true,
        })
      );
    } else {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: data.message || API_ERROR_MESSAGE,
          success: true,
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loading: false,
        error: e.message || API_ERROR_MESSAGE,
      })
    );
  }
};
const applyDisccount = (request) => async (dispatch) => {
  dispatch(Actions.updateProperty("loading", true));
  try {
    const { id, discount } = request;
    const data = await post(`products/apply-discount/${id}`, { discount });
    if (data.statusCode === 200) {
      dispatch(
        Actions.updateProperties({
          loading: false,
          message: data.message || "Discount added successfully",
        })
      );
      dispatch(getProducts());
    } else {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: data.message || API_ERROR_MESSAGE,
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loading: false,
        error: e.message || API_ERROR_MESSAGE,
      })
    );
  }
};

const removeFromHotLook = (request) => async (dispatch) => {
  dispatch(Actions.updateProperty("loading", true));
  try {
    const { id, isHotLook } = request;
    console.log(request);

    const data = await put(`products/${id}`, { isHotLook });
    if (data.statusCode === 200) {
      dispatch(
        Actions.updateProperties({
          loading: false,
          message: data.message || "Hot Look removed successfully",
        })
      );
      dispatch(getHotLookProducts());
    } else {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: data.message || API_ERROR_MESSAGE,
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loading: false,
        error: e.message || API_ERROR_MESSAGE,
      })
    );
  }
};

const editHotLook = (request) => async (dispatch) => {
  dispatch(Actions.updateProperty("loading", true));
  try {
    const { id, discount } = request;
    const data = await post(`products/apply-discount/${id}`, { discount });
    if (data.statusCode === 200) {
      dispatch(
        Actions.updateProperties({
          loading: false,
          message: data.message || "Hot Look edited successfully",
        })
      );
      dispatch(getHotLookProducts());
    } else {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: data.message || API_ERROR_MESSAGE,
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loading: false,
        error: e.message || API_ERROR_MESSAGE,
      })
    );
  }
};

const combineProducts = (body) => async (dispatch) => {
  dispatch(Actions.updateProperty("loading", true));
  dispatch(Actions.updateProperty("success", false));
  try {
    const data = await post(`products/combine-products`, body);
    if (data.statusCode === 200) {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: data.message,
          success: true,
        })
      );
    } else {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: data.message || API_ERROR_MESSAGE,
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loading: false,
        error: e.message || API_ERROR_MESSAGE,
      })
    );
  }
};

const getHotLookProducts = () => async (dispatch) => {
  dispatch(Actions.updateProperty("loading", true));
  try {
    let url = `products?&isHotLook=1`;

    const data = await get(url);
    if (data.statusCode === 200) {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: "",
          success: true,
          list: data.response.products || [],
          nextPageToken: (data.response || {}).nextPageToken,
        })
      );
    } else {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error:
            data.statusCode === 404 ? "" : data.message || API_ERROR_MESSAGE,
          list: [],
          nextPageToken: null,
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loading: false,
        error: e.message || API_ERROR_MESSAGE,
        list: [],
        nextPageToken: null,
      })
    );
  }
};

const changeProductStatus = (body, id) => async (dispatch) => {
  dispatch(Actions.updateProperty("loading", true));
  try {
    const data = await put(`products/${id}`, body);
    if (data.statusCode === 200) {
      // dispatch(getCategories())
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: "",
        })
      );
    } else {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: data.message || API_ERROR_MESSAGE,
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loading: false,
        error: e.message || API_ERROR_MESSAGE,
      })
    );
  }
};

const changeCategoryStatus = (body, id, parentID) => async (dispatch) => {
  dispatch(Actions.updateProperty("loading", true));
  try {
    const data = await put(`categories/${id}`, body);
    if (data.statusCode === 200) {
      if (parentID) dispatch(getCategories(parentID));
      else dispatch(getCategories());
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: "",
        })
      );
    } else {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: data.message || API_ERROR_MESSAGE,
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loading: false,
        error: e.message || API_ERROR_MESSAGE,
      })
    );
  }
};

const updateCategory = (body, id, parentID) => async (dispatch) => {
  dispatch(Actions.updateProperty("loading", true));
  try {
    const data = await put(`categories/${id}`, body, {
      contentType: "multipart/form-data",
    });
    if (data.statusCode === 200) {
      if (parentID) dispatch(getCategories(parentID));
      else dispatch(getCategories());
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: "",
        })
      );
    } else {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: data.message || API_ERROR_MESSAGE,
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loading: false,
        error: e.message || API_ERROR_MESSAGE,
      })
    );
  }
};

const setCategory = (data) => async (dispatch) => {
  dispatch(Actions.updateProperty("parentCategoryID", data.parentCategoryID));
  dispatch(
    Actions.updateProperty("parentSubCategoryID", data.parentCategoryID)
  );
};

export default {
  getProducts,
  getCategories,
  loadMoreProducts,
  getProductDetails,
  clearProductDetails,
  uploadCategoryImage,
  uploadProductImages,
  deleteProductImages,
  saveProductDetails,
  applyDisccount,
  combineProducts,
  searchProducts,
  getHotLookProducts,
  removeFromHotLook,
  editHotLook,
  changeProductStatus,
  changeCategoryStatus,
  setCategory,
  saveCategory,
  deleteCategory,
  addProducts,
  deleteProduct,
  updateCategory,
};
